<template>
  <form id="contact-form" @submit.prevent="submit">
    <div class="row">
      <div v-show="serverErrors" class="alert alert-danger col-12" role="alert">
        <p class="text-center mb-0" v-for="(error, index) in serverErrors" :key="index">{{ error[0] }}</p>
      </div>

      <div v-show="serverSuccess" class="succes-form-message col-12 mb-20" role="alert">
        <p class="text-center mb-0 text-white">{{ serverSuccess }}</p>
      </div>

      <div class="col-12">
        <div class="form-row">
          <div class="form-group col-12 col-lg-6">
            <div class="d-flex justify-content-between align-items-center">
              <label for="firstname" class="text-white ff-os small">Voornaam</label>
              <small class="text-danger" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</small>
            </div>
            <input v-model="contact.firstname" v-validate.disable="'required'" data-vv-as="Voornaam" type="text" class="form-control" id="firstname" name="firstname" placeholder="Typ je voornaam..." />
          </div>

          <div class="form-group col-12 col-lg-6">
            <div class="d-flex justify-content-between align-items-center">
              <label for="lastname" class="text-white ff-os small">Achternaam</label>
              <small class="text-danger" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</small>
            </div>
            <input v-model="contact.lastname" v-validate.disable="'required'" data-vv-as="Achternaam" type="text" class="form-control" id="lastname" name="lastname" placeholder="Typ je achternaam..." />
          </div>

          <div class="form-group col-12">
            <div class="d-flex justify-content-between align-items-center">
              <label for="phone" class="text-white ff-os small">Telefoonnummer</label>
              <small class="text-danger" v-show="errors.has('phone')">{{ errors.first('phone') }}</small>
            </div>
            <input v-model="contact.phone" v-validate.disable="'required'" data-vv-as="Telefoonnummer" type="text" class="form-control" id="phone" name="phone" placeholder="Typ je telefoonnummer..." />
          </div>

          <div class="form-group col-12">
            <div class="d-flex justify-content-between align-items-center">
              <label for="email" class="text-white ff-os small">E-mailadres</label>
              <small class="text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</small>
            </div>
            <input v-model="contact.email" v-validate.disable="'required|email'" type="email" data-vv-as="E-mail" class="form-control" id="email" name="email" placeholder="Typ je e-mailadres..." />
          </div>
        </div>
      </div>

      <div class="form-group w-100 col-12" style="height: 100%">
        <div class="d-flex justify-content-between align-items-center">
          <label for="message" class="text-white ff-os small">{{ textTitle }}</label>
          <small class="text-danger" v-show="errors.has('message')">{{ errors.first('message') }}</small>
        </div>
        <textarea v-model="contact.message" v-validate.disable="'required'" rows="6" data-vv-as="Bericht" class="form-control" id="message" name="message" :placeholder="textPlaceholder"></textarea>
      </div>
    </div>

    <button type="submit" class="btn btn-black" v-bind:class="{ disabled: spinner }">
      {{ btnTitle }}
      <span v-show="spinner">
        <i class="fas fa-circle-notch fa-spin"></i>
      </span>
    </button>
  </form>
</template>

<script>
export default {
  props: {
    estate: {
      required: false,
    },
    type: {
      required: true,
    },
    btnTitle: {
      default: 'Verstuur',
    },
    textTitle: {
      default: 'Waar kunnen we je mee helpen?',
    },
    textPlaceholder: {
      default: 'Waar kunnen we je mee helpen?',
    },
    estateUrl: {
      required: false,
    },
    layout: {
      required: false,
      default: 'contact',
    },
  },
  data() {
    return {
      contact: {
        type: this.type,
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        message: '',
        estateTitle: this.estate ? this.estate.name : false,
        estateId: this.estate ? this.estate.id : false,
        estateUrl: this.estateUrl ? this.estateUrl : false,
        estateStreet: this.estate ? this.estate.address : false,
        estateNumber: this.estate ? this.estate.number : false,
        estateCity: this.estate ? this.estate.city : false,
        page: window.location.href,
      },
      serverErrors: false,
      serverSuccess: false,
      spinner: false,
      locationPath: false,
    };
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.spinner = true;
          axios
            .post('/api/v1/contact', this.contact)
            .then((response) => {
              this.spinner = false;
              this.contact.firstname = '';
              this.contact.lastname = '';
              this.contact.phone = '';
              this.contact.email = '';
              this.contact.message = '';
              this.serverSuccess = window.handleSuccess(response);
            })
            .catch((errors) => {
              this.spinner = false;
              this.serverErrors = window.handleError(errors);
            });
        }
      });
    },
  },
};
</script>
